<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="mono-logo-container text-center">
        <img src="@/assets/logo_white.svg" alt="Traitstack" />
      </div>
      <div class="field-error" :class="{ toggled: error }">
        {{ errorMessage }}
      </div>
      <div id="authPanel" class="panel auth-panel">
        <div v-if="mode === 'resetPassword'">
          <h1 class="h2">Reset password</h1>
          <form action="javascript:void(0);">
            <input
              type="password"
              v-model="password"
              class="form-control"
              placeholder="New password"
            />
            <button
              type="submit"
              @click="handleChangePassword"
              :class="{ active: loading, success: success }"
              class="btn btn-primary btn-auth btn-loader"
            >
              <span>Change password</span>
            </button>
          </form>
          <div class="divider-text">
            <span>or</span>
          </div>
          <p class="auth-info">
            Go back to
            <router-link to="/sign-in">sign in</router-link>
          </p>
        </div>
        <div v-if="mode === 'verifyEmail'">
          <div v-if="!emailVerified">
            <h1 class="h2">Verifying email</h1>
            <p>We are verifying the email address. Hold on tight!</p>
          </div>
          <div v-if="emailVerified">
            <h1 class="h2">Email address verified!</h1>
            <p>Your email address is verified succesfully.</p>
            <div class="text-center" style="margin-top: 20px">
              <button v-if="loggedIn" @click="$signOut()" class="btn btn-primary" to="/">Re-sign in</button>
              <router-link v-if="!loggedIn" class="btn btn-primary" to="/sign-in">Sign in</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "signin",
  components: {},
  mounted: function() {
    this.mode = this.$route.query.mode;
    this.actionCode = this.$route.query.oobCode;
    this.continueUrl = this.$route.query.continueUrl;

    if (this.mode === "verifyEmail") {
      this.handleVerifyEmail();
    }
  },
  data() {
    return {
      password: "",
      mode: null,
      actionCode: null,
      continueUrl: null,
      loading: false,
      error: false,
      errorMessage: "",
      success: false,
      emailVerified: false,
      loggedIn: false
    };
  },
  methods: {
    handleVerifyEmail: function() {
      console.log(this.actionCode);
      firebase
        .auth()
        .applyActionCode(this.actionCode)
        .then(() => {
          this.emailVerified = true;
          var user = firebase.auth().currentUser;
          if (user) {
            this.loggedIn = true;
          }
        })
        .catch(err => {
          this.loading = false;
          this.error = true;
          this.errorMessage = err.message;
          document.getElementById("authPanel").classList.remove("error");
          void document.getElementById("authPanel").offsetWidth;
          document.getElementById("authPanel").classList.add("error");
        });
    },
    handleChangePassword: function() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      firebase
        .auth()
        .confirmPasswordReset(this.actionCode, this.password)
        .then(() => {
          this.loading = false;
          this.success = true;
          this.error = false;
          this.$toast.open({
            message: "Your password has been changed",
            type: "success"
          });
          setTimeout(() => {
            this.$router.replace({ path: "/sign-in" });
          }, 1500);
        })
        .catch(err => {
          this.loading = false;
          this.error = true;
          this.errorMessage = err.message;
          document.getElementById("authPanel").classList.remove("error");
          void document.getElementById("authPanel").offsetWidth;
          document.getElementById("authPanel").classList.add("error");
        });
    }
  }
};
</script>
